import { render, staticRenderFns } from "./AllQuestionsTable.vue?vue&type=template&id=108b4172"
import script from "./AllQuestionsTable.vue?vue&type=script&lang=js"
export * from "./AllQuestionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports